import { BundleType } from './builder-config';

/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
export function determineBundleType(bundleType?: BundleType) {
  if (bundleType) {
    return bundleType;
  }

  // Chrome 49 & Chrome 51
  const hasSearchParams =
    window.URLSearchParams &&
    URLSearchParams.prototype &&
    window.URL &&
    URL.prototype &&
    URL.prototype.hasOwnProperty('searchParams');
  // Chrome 54
  const hasPrepend = Element && Element.prototype && Element.prototype.hasOwnProperty('prepend');
  // Chrome 54
  const hasObjectEntries = Object && Object.hasOwnProperty('entries');
  let hasObjectSpread;
  try {
    (0, eval)('var a = {foo: 1};var b = {...a};');
    hasObjectSpread = true;
  } catch {
    hasObjectSpread = false;
  }

  const useES5 = !hasSearchParams || !hasPrepend || !hasObjectEntries || !hasObjectSpread;

  return useES5 ? BundleType.ES5 : BundleType.ES6;
}

/* eslint-enable no-prototype-builtins */
/* eslint-enable @typescript-eslint/no-unnecessary-condition */
